module.exports = __webpack_public_path__ + "img/mr.3235293f.png";